import { render, staticRenderFns } from "./QuotationDefaultCostsCard.vue?vue&type=template&id=533e0f24"
import script from "./QuotationDefaultCostsCard.vue?vue&type=script&lang=ts"
export * from "./QuotationDefaultCostsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports